import React, { Component } from 'react';
import { Route, Switch } from 'react-router';

import * as ROUTES from 'config/routes';
import RealtimeList from './realtime-list';
import { PageContent } from 'components';
import { PageContainer } from 'smart-components';
import { userIsAuthenticatedRedir } from 'hocs/auth';

class RealtimeView extends Component {
	render() {
		return (
			<PageContainer>
				<PageContent>
					<PageContent.Main>
						<Switch>
							<Route
								exact
								path={ROUTES.REALTIME_VIEW}
								component={RealtimeList}
							/>
						</Switch>
					</PageContent.Main>
				</PageContent>
			</PageContainer>
		);
	}
}

export default userIsAuthenticatedRedir(RealtimeView);



// WEBPACK FOOTER //
// ./src/pages/realtime-view/index.js